/**
 * Get the coverage percentage of a catalog item
 * @param totalAssetCount - The total number of assets in the catalog
 * @param assetCount - The number of assets in the catalog item
 * @returns
 */
export function getCatalogCoveragePercent(props: {
    totalAssetCount: number;
    assetCount: number;
}): string {
    const { totalAssetCount, assetCount } = props;

    const pct =
        totalAssetCount > 0
            ? Math.min(100, Math.round((assetCount / totalAssetCount) * 100))
            : 0;

    return `${pct}%`;
}
